import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { addDate } from "keautils";
type Entity = models.DocumentacionDTO;
import { columnas } from "./columns";
import { observeResource } from "kea-resource";
import { onImprimirDocumentacion } from "../logic";
const resource = resources.Documentacion;

interface FiltroDocumentacion {
    fechaIni: Date;
    fechaFin: Date;
}
interface State {

}
export class DocumentacionList extends React.PureComponent<{}, FiltroDocumentacion> {
    constructor(props) {
        super(props);

        var now = new Date();
        this.state = {
            fechaIni: addDate(now, "days", -3),
            fechaFin: addDate(now, "days", 1)
        };
    }
    onVer = (x: Entity) => history.go(`./${x.IdRegistro}/`);
    onRegresar = () => history.go("..//");
    onImprimir = async (x: Entity) => await onImprimirDocumentacion(x.IdRegistro);
    
    render() {
        const cols = columnas(this);
        return (
            <div>
                <h3>Documentaciones</h3>

                {kea.autogrid(6, [
                    <kea.DateTime value={this.state.fechaIni} onChange={x => x && this.setState({ fechaIni: x })} label="Fecha de inicio" time={true} />,
                    <kea.DateTime value={this.state.fechaFin} onChange={x => x && this.setState({ fechaFin: x })} label="Fecha final" time={true} />
                ])}
                <kea.Grid2 columnas={cols} cookieKey={"DocumentacionListCookieKey"} items={observeResource(resources.Documentacion.Query, this.state.fechaIni, this.state.fechaFin)} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/documentacion/list/list.tsx